import { render, staticRenderFns } from "./NoticeMgt.vue?vue&type=template&id=617638d8&scoped=true&"
import script from "./NoticeMgt.vue?vue&type=script&lang=js&"
export * from "./NoticeMgt.vue?vue&type=script&lang=js&"
import style0 from "./NoticeMgt.vue?vue&type=style&index=0&id=617638d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617638d8",
  null
  
)

export default component.exports